﻿'use strict';
//Utility
var React = require('react');
var ContentService = require('../../services/ContentService');

//constants
var BeneficiaryConstants = require('../../constants/BeneficiaryDetailsConstant.js');

//Components
var RadioInput = require('../Common/RadioInput.jsx');

var BeneficiaryRelationshipInfo = React.createClass({

    bottomText: function (text){
        return (
              <div className="bfyd-relationship-help"> 
                   <span dangerouslySetInnerHTML={{__html:text}} />
              </div>
        )
    },

    render: function() {
            var content = ContentService.getContent().beneficiaryDetails;
            var relationshipText = '';

            switch(this.props.data.relationship){
                case BeneficiaryConstants.Relationship.SPOUSE:
                    relationshipText = content.relationshipSpouse;
                    break;
                case BeneficiaryConstants.Relationship.CHILD:
                    relationshipText = content.relationshipChild;
                    break;
                case BeneficiaryConstants.Relationship.FINANCIAL_DEPENDANT:
                    relationshipText = content.relationshipFinancial;
                    break;
                case BeneficiaryConstants.Relationship.INTERDEPENDANT:
                    relationshipText = content.relationshipInter;
                    break;
                default:
                    relationshipText = '';
                    break;
            }

            var showBottomText = relationshipText.length > 0;

            return (
                <section>
                    <RadioInput id="bfyDrelationship"
                                label="Relationship to you"
                                model="relationship"
                                data={BeneficiaryConstants.RelationshipData}
                                value={this.props.data.relationship}
                                onChange={this.props.onChange}
                                errorList={this.props.errorList} 
                                helpText={content.relationshipHelp}/>

                               {showBottomText ? this.bottomText(relationshipText) : null}
                </section>
            );    
         }
});

module.exports = BeneficiaryRelationshipInfo;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/BeneficiaryDetails/BeneficiaryRelationshipInfo.jsx